import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Button } from 'ui';

const PreviewButton = ({ previewPath, lessonId, disabled }) => {
  const handlePreviewClick = e => {
    e.preventDefault();
    const previewWindow = window.open(
      previewPath,
      `lesson_preview_${lessonId}`,
    );

    if (previewWindow) {
      previewWindow.location.href = previewPath;
      previewWindow.focus();
      previewWindow.location.reload();
    }
  };

  return (
    <Button
      disabled={disabled}
      onClick={handlePreviewClick}
      className="trk_button_readiness_preview-lesson"
    >
      {t('lessons.editor.preview')}
    </Button>
  );
};

const mapStateToProps = ({ editor }) => ({
  previewPath: get(editor.currentSection, 'preview_path'),
  lessonId: editor.lessonId,
});

export default connect(mapStateToProps)(PreviewButton);
